<div 
    *ngIf="material"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();"
>
    <div class="flex w-full max-w-screen-md flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <!-- THREAT DETAILS -->
        <div class="flex min-w-full bg-white p-10 rounded-md text-center shadow-lg">
            <div class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row items-center justify-between">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap">
                        Material: <span class="text-nside-orange-400">{{ material.material }}</span>
                    </h2>
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeModal();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full flex flex-col items-center p-4 rounded-lg">
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Contact</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ material.contact_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Location:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ material.location }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Last Updated By:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ material.last_updated_user_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-52 flex items-center text-nside-gray-300">
                            <p>Last Updated At:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ material.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</p>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</div>